import { Amplify } from "aws-amplify";

import { Route, Switch, useLocation } from "wouter";

import "@aws-amplify/ui-react/styles.css";
import GlobalStyle from "@joinTrilo/ui/styles/GlobalStyle";
import { IntercomProvider } from "react-use-intercom";
import { useAlert } from "src/hooks/context";
import { Pay } from "./components/Pay/Pay";
import { useEstablish } from "./hooks/useEstablish/useEstablish";
import posthog, { PostHog } from "posthog-js";

import { AlertProvider, AuthProvider, PaymentProvider } from "./context";

import PageLayout from "./components/Layout/Page/PageLayout";

import "./App.css";
import { Callback } from "./components/Callback/Callback";

import {
    POSTHOG_API_KEY,
    POSTHOG_URL,
    isPosthogTraceableStage,
} from "src/utils/posthog";
import { useEffect } from "react";
import { Summary } from "./components/Summary/Summary";

const amplifyConfig = {
    Auth: {
        region: process.env.REACT_APP_REGION,
        userPoolId: process.env.REACT_APP_USERPOOL_ID,
        userPoolWebClientId: process.env.REACT_APP_USERPOOL_WEBCLIENT_ID,
        mandatorySignIn: false,
        signUpVerificationMethod: "code", // 'code' | 'link'
    },
    aws_appsync_graphqlEndpoint: process.env.REACT_APP_GRAPHQL_API_URL,
    aws_appsync_region: process.env.REACT_APP_REGION,
    aws_appsync_authenticationType: "AWS_IAM",
    aws_cognito_identity_pool_id: process.env.REACT_APP_IDENTITY_POOL,
    aws_cognito_region: process.env.REACT_APP_REGION,
};

console.log("stage >>>", process.env.REACT_APP_STAGE);
Amplify.configure(amplifyConfig);

const INTERCOM_APP_ID = "t3o6g8qc";

export function TApp() {
    useEstablish();

    useEffect(() => {
        posthog.init(POSTHOG_API_KEY, {
            api_host: POSTHOG_URL,
            loaded: (posthog: PostHog) => {
                if (!isPosthogTraceableStage({ stage: process.env.REACT_APP_STAGE })) {
                    posthog.opt_out_capturing();
                }
            },
        });
    }, []);

    const { alertState } = useAlert();
    const [location, setLocation] = useLocation();

    const goToPaymentMethodScreen = (paymentId: string) => {
        setLocation(`/paymentmethod/${paymentId}`);
    };

    const goToPaymentSummary = (foreignId: string) => {
        // setLocation(`/summary/${foreignId}`);
        window.location.href = `/summary/${foreignId}`;
    };

    return (
        <>
            <GlobalStyle />
            <div className="App">
                <PageLayout
                    navigateBack={undefined}
                    progress={90}
                    errorMessage={alertState.message ?? undefined}
                >
                    <Switch>
                        <Route path="/pay/:amount/:recipient/:note">
                            {(params) => (
                                <Pay
                                    {...params}
                                    recipient={{ id: params.recipient }}
                                    updateUrl={(id) => {
                                        setLocation(`${location}/${id}`);
                                    }}
                                    goToPaymentMethodScreen={
                                        goToPaymentMethodScreen
                                    }
                                    goToPaymentSummary={goToPaymentSummary}
                                />
                            )}
                        </Route>
                        <Route path="/pay/:amount/:recipient/:note/:reference">
                            {(params) => (
                                <Pay
                                    {...params}
                                    reference={params.reference}
                                    recipient={{ id: params.recipient }}
                                    goToPaymentMethodScreen={
                                        goToPaymentMethodScreen
                                    }
                                    goToPaymentSummary={goToPaymentSummary}
                                />
                            )}
                        </Route>
                        <Route path="/callback/t/:bankId">
                            {(params) => (
                                <>
                                    <Callback goToPaymentSummary={goToPaymentSummary} />
                                </>

                            )}
                        </Route>
                        <Route path="/callback/:bankId">
                            {(params) => (
                                <>
                                    <Callback goToPaymentSummary={goToPaymentSummary} />
                                </>

                            )}
                        </Route>
                        <Route path="/summary/:foreignId">
                            {(params) => (
                                <>
                                    <Summary foreignId={params.foreignId} />
                                </>

                            )}
                        </Route>
                    </Switch>
                </PageLayout>
            </div>
        </>
    );
}

const App = () => {
    return (
        <AuthProvider>
            <AlertProvider>
                <PaymentProvider>
                    <IntercomProvider appId={INTERCOM_APP_ID}>
                        <TApp />
                    </IntercomProvider>
                </PaymentProvider>
            </AlertProvider>
        </AuthProvider>
    );
};

export default App;
